import React from 'react';

const PromotionsPage = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold">Акции</h1>
      {/* Promotions content */}
      <div className="my-4">
        {/* Placeholder for promotions content */}
      </div>
    </div>
  );
};

export default PromotionsPage;
